// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Cr5wr","filled":"Button_filled__8fSDR","plain":"Button_plain__T4kka","white":"Button_white__b+uE+","main":"Button_main__r1wNG","round":"Button_round__jXIx0"};